import { render } from "./IngressClass.vue?vue&type=template&id=d6680c46"
import script from "./IngressClass.vue?vue&type=script&lang=js"
export * from "./IngressClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__